import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AdvisorKeys } from "web_myplann/Api/Advisor/AdvisorKeys";
import { addConnectedAdvisorToCache } from "web_myplann/Api/Advisor/addConnectedAdvisorToCache";
import { removePendingAdvisorAndInvalidate } from "web_myplann/Api/Advisor/removePendingAdvisorAndInvalidate";
import type { AssignedAgentsQueryData } from "web_myplann/Api/Advisor/Types/AssignedAgentsQueryData";
import {
	type PatchAgentIdConnectionAcceptV2FetchResponse,
	patchAgentIdConnectionAcceptV2,
	UserAgentStatusEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useAdvisorAcceptConnectionMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationKey: AdvisorKeys.acceptConnection(),
		mutationFn: processResponse<
			number,
			PatchAgentIdConnectionAcceptV2FetchResponse
		>((advisorId) => patchAgentIdConnectionAcceptV2(advisorId)),
		onSuccess: (_response, advisorId) => {
			const pending = queryClient.getQueryData<AssignedAgentsQueryData>(
				AdvisorKeys.assignedAgents(UserAgentStatusEnum.PendingClient),
			);
			const advisor = pending?.data.find((item) => item.id === advisorId);

			queryClient.setQueryData<AssignedAgentsQueryData>(
				AdvisorKeys.assignedAgents(UserAgentStatusEnum.Connected),
				(cached) => addConnectedAdvisorToCache(cached, advisor),
			);

			return removePendingAdvisorAndInvalidate(queryClient, advisorId);
		},
	});
};
